import React from 'react';
import ReactDOM from 'react-dom';
import { MultichainContainer } from '@popup/multichain/multichain-container';
import './style.scss';
ReactDOM.render(React.createElement(MultichainContainer, null), document.getElementById('root'));
